module.exports = __webpack_public_path__ + "static/media/Asset 15.a106147f.png";